import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import bookInfo from './modules/book-info'
import orderInfo from './modules/order-info'
import lngLat from './modules/lng-lat'
import newGas from './modules/newGas'
import appointment from './modules/appointment'
import nuclear from './modules/nuclear'
import bury from './modules/bury'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    app,
    bookInfo,
    orderInfo,
    lngLat,
    appointment,
    newGas,
    nuclear,
    bury
  }
})